import { CCApiService } from './api-service';
import { UIConfig } from './config-service';

export class SitesService {
  static ApiService: CCApiService;
  static sitesAPI: string;
  static siteEnvironmentAPI: string;
  static apiBasePath: string;

  static init(config: UIConfig) {
    this.ApiService = new CCApiService(config.authClientId, config.authIssuerUri);
    this.apiBasePath = config.apiBasePath;
  }

  static async getSites(customerId, filter: Record<string, any>): Promise<any> {
    this.sitesAPI = `${this.apiBasePath}/customers/${customerId}/sites`;
    return this.ApiService.performFetch(`${this.sitesAPI}?${new URLSearchParams(filter)}`).then((sites) => sites);
  }

  static async getSite(customerId, siteId): Promise<any> {
    this.sitesAPI = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}`;
    return this.ApiService.performFetch(this.sitesAPI).then((sites) => sites);
  }

  static async getSiteEnvironments(customerId, siteId, filter: Record<string, any>): Promise<any> {
    this.siteEnvironmentAPI = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments`;
    return this.ApiService.performFetch(`${this.siteEnvironmentAPI}?${new URLSearchParams(filter)}`).then(
      (sites) => sites
    );
  }

  static async getSiteEnvironment(customerId, siteId, environmentId): Promise<any> {
    this.siteEnvironmentAPI = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${environmentId}`;
    return this.ApiService.performFetch(this.siteEnvironmentAPI).then((sites) => sites);
  }

  static async createSite({ customerId, site }): Promise<any> {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(site),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites`;
    return this.ApiService.performFetch(api, fetchOptions).then((entity) => {
      return entity;
    });
  }

  static async updateSite({ siteId, customerId, site }): Promise<any> {
    const fetchOptions = {
      method: 'PUT',
      body: JSON.stringify(site),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}`;
    return this.ApiService.performFetch(api, fetchOptions).then((entity) => {
      return entity;
    });
  }

  static async deleteSite({ customerId, siteId }): Promise<any> {
    const fetchOptions = {
      method: 'DELETE',
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}`;
    return this.ApiService.performFetch(api, fetchOptions);
  }

  static async createSiteEnvironment({ customerId, siteId, siteEnvironment }): Promise<any> {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(siteEnvironment),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments`;
    return this.ApiService.performFetch(api, fetchOptions).then((entity) => {
      return entity;
    });
  }

  static async updateSiteEnvironment({ customerId, siteId, siteEnvironmentId, siteEnvironment }): Promise<any> {
    const fetchOptions = {
      method: 'PUT',
      body: JSON.stringify(siteEnvironment),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}`;
    return this.ApiService.performFetch(api, fetchOptions).then((entity) => {
      return entity;
    });
  }

  static async deleteSiteEnvironment({ customerId, siteId, siteEnvironmentId }): Promise<any> {
    const fetchOptions = {
      method: 'DELETE',
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}`;
    return this.ApiService.performFetch(api, fetchOptions);
  }

  static async getSearchService({ customerId, siteId, siteEnvironmentId }): Promise<any> {
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-service`;
    return this.ApiService.performFetch(api).then((searchService) => searchService);
  }

  static async deleteSearchService({ customerId, siteId, siteEnvironmentId }): Promise<any> {
    const fetchOptions = {
      method: 'DELETE',
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-service`;
    return this.ApiService.performFetch(api, fetchOptions);
  }

  static async createSearchService({ customerId, siteId, siteEnvironmentId, searchService }): Promise<any> {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(searchService),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-service`;
    return this.ApiService.performFetch(api, fetchOptions).then((createdSearchService) => createdSearchService);
  }

  static async updateSearchService({ customerId, siteId, siteEnvironmentId, searchService }): Promise<any> {
    const fetchOptions = {
      method: 'PUT',
      body: JSON.stringify(searchService),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-service`;
    return this.ApiService.performFetch(api, fetchOptions).then((updatedSearchService) => updatedSearchService);
  }

  static async listSearchServices({ customerId, siteId, siteEnvironmentId, filter = {} }): Promise<any> {
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-services`;
    return this.ApiService.performFetch(`${api}?${new URLSearchParams(filter)}`).then(
      (searchServices) => searchServices
    );
  }

  static async getSearchServiceById({ customerId, siteId, siteEnvironmentId, searchServiceId }): Promise<any> {
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-services/${searchServiceId}`;
    return this.ApiService.performFetch(api).then((searchService) => searchService);
  }

  static async createSearchServiceInEnvironment({
    customerId,
    siteId,
    siteEnvironmentId,
    searchService,
  }): Promise<any> {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(searchService),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-services`;
    return this.ApiService.performFetch(api, fetchOptions).then((createdSearchService) => createdSearchService);
  }

  static async updateSearchServiceById({
    customerId,
    siteId,
    siteEnvironmentId,
    searchServiceId,
    searchService,
  }): Promise<any> {
    const fetchOptions = {
      method: 'PUT',
      body: JSON.stringify(searchService),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-services/${searchServiceId}`;
    return this.ApiService.performFetch(api, fetchOptions).then((updatedSearchService) => updatedSearchService);
  }

  static async deleteSearchServiceById({ customerId, siteId, siteEnvironmentId, searchServiceId }): Promise<any> {
    const fetchOptions = {
      method: 'DELETE',
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/search-services/${searchServiceId}`;
    return this.ApiService.performFetch(api, fetchOptions);
  }

  static async getAllSiteEnvironments(customerId, filter: Record<string, any> = {}): Promise<any> {
    const api = `${this.apiBasePath}/customers/${customerId}/site-environments`;
    return this.ApiService.performFetch(`${api}?${new URLSearchParams(filter)}`).then((environments) => environments);
  }

  static async getTypeaheadService({ customerId, siteId, siteEnvironmentId }): Promise<any> {
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/typeahead-service`;
    return this.ApiService.performFetch(api).then((typeaheadService) => typeaheadService);
  }

  static async deleteTypeaheadService({ customerId, siteId, siteEnvironmentId }): Promise<any> {
    const fetchOptions = {
      method: 'DELETE',
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/typeahead-service`;
    return this.ApiService.performFetch(api, fetchOptions);
  }

  static async createTypeaheadService({ customerId, siteId, siteEnvironmentId, typeaheadService }): Promise<any> {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(typeaheadService),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/typeahead-service`;
    return this.ApiService.performFetch(api, fetchOptions).then((createdTypeaheadService) => createdTypeaheadService);
  }

  static async updateTypeaheadService({ customerId, siteId, siteEnvironmentId, typeaheadService }): Promise<any> {
    const fetchOptions = {
      method: 'PUT',
      body: JSON.stringify(typeaheadService),
    };
    const api = `${this.apiBasePath}/customers/${customerId}/sites/${siteId}/environments/${siteEnvironmentId}/typeahead-service`;
    return this.ApiService.performFetch(api, fetchOptions).then((updatedTypeaheadService) => updatedTypeaheadService);
  }
}
